"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyCaptureSummaryStatus = void 0;
var StudyCaptureSummaryStatus;
(function (StudyCaptureSummaryStatus) {
    StudyCaptureSummaryStatus["NotAvailable"] = "NA";
    StudyCaptureSummaryStatus["InComplete"] = "INCOMPLETE";
    StudyCaptureSummaryStatus["PartiallyCompleted"] = "PARTIALLY_COMPLETED";
    StudyCaptureSummaryStatus["Completed"] = "COMPLETED";
})(StudyCaptureSummaryStatus = exports.StudyCaptureSummaryStatus || (exports.StudyCaptureSummaryStatus = {}));
//# sourceMappingURL=studyCaptureSummaryStatus.js.map